<template>
  <div>
    <van-field
      v-model="temp.企业名称"
      label="企业名称"
      placeholder="企业名称"
      :rules="[{ required: true, message: '企业名称' }]"
    />
    <van-field
      v-model="temp.岗位名称"
      label="岗位名称"
      placeholder="岗位名称"
      :rules="[{ required: true, message: '岗位名称' }]"
    />

    <van-field
      v-model="temp.起始时间"
      readonly
      clickable
      label="起始时间"
      placeholder="选择起始时间"
      @click="ShowDatePup('起始时间')"
      :rules="[{ required: true, message: '选择起始时间' }]"
    />

    <van-field
      v-model="temp.结束时间"
      readonly
      clickable
      label="结束时间"
      placeholder="选择结束时间"
      @click="ShowDatePup('结束时间')"
      :rules="[{ required: true, message: '选择结束时间' }]"
    />

    <van-field
      v-model="temp.岗位描述"
      type="text"
      label="岗位描述"
      placeholder="岗位描述"
      :rules="[{ required: true, message: '岗位描述' }]"
    />
    <div style="margin: 16px">
      <van-row>
        <van-col span="8"
          ><van-button round block @click.prevent="$emit('handlerStep', -1)"
            >上一步</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button round block @click.prevent="addData()"
            >保存并新增</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button round block @click.prevent="$emit('handlerStep', 1)"
            >下一步</van-button
          >
        </van-col>
      </van-row>
        </div>
        <van-popup v-model="showDatePup" position="bottom">
      <van-datetime-picker
         type="date" format="yyyy-MM-dd"  value-format="yyyy-MM-dd" 
        title="日期"
        :min-date="minDate"
        @cancel="showDatePup = false"
        @confirm="onDate"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "baseinfo",
  props: ["info"],
  data() {
    return {
      temp: {},
      showDatePup: false,
       minDate: new Date(1960, 0, 1),
    };
  },
  methods: {
    ShowDatePup(dateFieldname) {
      this.showDatePup = true;
      this.dateFieldname = dateFieldname;
    },
    addData() {
      console.log(this.info);
      this.info.push(this.temp);
      this.temp = {};
    },
    onDate(value) {
      console.log("www");
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();
      let v = year + "年" + month + "月" + day + "日";
      this.$set(this.temp, this.dateFieldname, v);
      this.showDatePup = false;
    },
  },
};
</script>
<style scoped>
.prop {
  font-size: 12px;

  background-color: chocolate;
  color: cadetblue;
}
</style>
